import React from "react";

export default function BrandFooter({ className = "" }) {
  const classes = ["brand-footer", className].filter(Boolean).join(" ");

  return (
    <footer className={classes}>
      <span>© </span>
      <a
        className="brand-footer-link"
        href="https://aizensim6.com/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Visit the AiZenSiM 6 website (opens in a new tab)"
      >
        AiZenSiM<sup>6</sup>
      </a>
      <span> 2026. All rights reserved.</span>
    </footer>
  );
}
